import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { IBrand } from './brand';
import { IBrandFormValues } from './brandFormValues';
import { IBrandUpsert } from './brandUpsert';

export default class BrandModelHelper {
    public static createFormValues = (brand : IBrand | null) : IBrandFormValues => {
        if (!brand) return {
            id: 0,
            guid: uuidV4(),
            code: '',
            description: '',
            isActive: true,
        };

        return {
            id: brand.id,
            guid: brand.guid,
            code: brand.code,
            description: brand.description,
            isActive: brand.isActive,
        };
    };

    public static createUpsert = (formValues : IBrandFormValues) : IBrandUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            code: formValues.code,
            description: formValues.description,
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<IBrandFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        code: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        description: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        isActive: Yup.boolean().required('Required'),
    });
}
